<template>
  <div class="wrap">
    <Head></Head>
    <navigationbar ref="navbar"></navigationbar>
    <div class="banner">
      <swiper
        v-if="home_info.Banners"
        class="swiper"
        :options="swiperOption"
        ref="mySwiper"
      >
        <swiper-slide
          class="swiper-item"
          v-for="item in home_info.Banners"
          :key="item.DataId"
        >
          <div
            class="img"
            :style="{ backgroundImage: 'url(' + item.ImageUrl + ')' }"
          ></div>
        </swiper-slide>
      </swiper>
      <div class="pagination">
        <span
          class="pagitation-point"
          v-for="(item, index) in home_info.Banners"
          :key="item.DataId"
          :class="bannerIndex == index ? 'bullet-active ' : 'bullet'"
          @click="bannerSwich(index)"
        >
        </span>
      </div>
    </div>

    <div class="home-bg">
      <div class="width c flex flex-direction justify-center">
        <!-- 热门推荐 -->
        <div class="hot" v-if="home_info.HotRecommend">
          <div class="t flex align-center justify-center">
            <img class="img" src="../../../assets/home/icon-home-hot.png" />
            <span class="font-color-34">热门</span>
            <span class="span font-color-48">推荐</span>
          </div>
          <div v-if="home_info.HotRecommend" class="flex flex-wrap">
            <courseItem
              v-for="(item, index) in home_info.HotRecommend"
              :key="index"
              :index="item.Id"
              :item="item"
            >
            </courseItem>
          </div>
        </div>

        <!--  -->
        <div class="t1" v-if="home_info.CatalogCourseList">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-tra.png" />
              <span class="font-color-34">{{
                home_info.CatalogCourseList[0].pre
              }}</span>
              <span class="last font-color-48">{{
                home_info.CatalogCourseList[0].tail
              }}</span>
            </div>
            <div
              class="more flex align-center cursor-pointer"
              @click="toCourse(home_info.CatalogCourseList[0].CatalogId)"
            >
              <p class="font-color-87 font-size-25">更多</p>
              <img
                class="icon"
                src="../../../assets/home/icon-home-arrow.png"
              />
            </div>
          </div>
          <div class="width flex flex-wrap">
            <courseItem
              v-for="(item, index) in home_info.CatalogCourseList[0].Courses"
              :key="index+100"
              :index="item.Id"
              :item="item"
            >
            </courseItem>
          </div>
        </div>

        <div class="t2" v-if="home_info.CatalogCourseList">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-cla.png" />
              <span class="font-color-34">{{
                home_info.CatalogCourseList[1].pre
              }}</span>
              <span class="last font-color-48">{{
                home_info.CatalogCourseList[1].tail
              }}</span>
            </div>
            <div
              class="more flex align-center cursor-pointer"
              @click="toCourse(home_info.CatalogCourseList[1].CatalogId)"
            >
              <p class="font-color-87 font-size-25">更多</p>
              <img
                class="icon"
                src="../../../assets/home/icon-home-arrow.png"
              />
            </div>
          </div>
          <div class="width flex flex-wrap">
            <courseItem
              v-for="(item, index) in home_info.CatalogCourseList[1].Courses"
              :key="index+200"
              :index="item.Id"
              :item="item"
            >
            </courseItem>
          </div>
        </div>

        <div class="t3" v-if="home_info.CatalogCourseList">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-find.png" />
              <span class="font-color-34">{{
                home_info.CatalogCourseList[2].pre
              }}</span>
              <span class="last font-color-48">{{
                home_info.CatalogCourseList[2].tail
              }}</span>
            </div>
            <div
              class="more flex align-center cursor-pointer"
              @click="toCourse(home_info.CatalogCourseList[2].CatalogId)"
            >
              <p class="font-color-87 font-size-25">更多</p>
              <img
                class="icon"
                src="../../../assets/home/icon-home-arrow.png"
              />
            </div>
          </div>
          <div class="width flex flex-wrap">
            <courseItem
              v-for="(item, index) in home_info.CatalogCourseList[2].Courses"
              :key="index+300"
              :index="item.Id"
              :item="item"
            >
            </courseItem>
          </div>
        </div>

        <div class="t4" v-if="home_info.CatalogCourseList">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-art.png" />
              <span class="font-color-34">{{
                home_info.CatalogCourseList[3].pre
              }}</span>
              <span class="last font-color-48">{{
                home_info.CatalogCourseList[3].tail
              }}</span>
            </div>
            <div
              class="more flex align-center cursor-pointer"
              @click="toCourse(home_info.CatalogCourseList[3].CatalogId)"
            >
              <p class="font-color-87 font-size-25">更多</p>
              <img
                class="icon"
                src="../../../assets/home/icon-home-arrow.png"
              />
            </div>
          </div>
          <div class="width flex flex-wrap">
            <courseItem
              v-for="(item, index) in home_info.CatalogCourseList[3].Courses"
              :key="index+400"
              :index="item.Id"
              :item="item"
            >
            </courseItem>
          </div>
        </div>

        <div class="t5" v-if="home_info.CatalogCourseList">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img
                class="img"
                src="../../../assets/home/icon-home-comunicate.png"
              />
              <span class="font-color-34">{{
                home_info.CatalogCourseList[4].pre
              }}</span>
              <span class="last font-color-48">{{
                home_info.CatalogCourseList[4].tail
              }}</span>
            </div>
            <div
              class="more flex align-center cursor-pointer"
              @click="toCourse(home_info.CatalogCourseList[4].CatalogId)"
            >
              <p class="font-color-87 font-size-25">更多</p>
              <img
                class="icon"
                src="../../../assets/home/icon-home-arrow.png"
              />
            </div>
          </div>
          <div class="width flex flex-wrap">
            <courseItem
              v-for="(item, index) in home_info.CatalogCourseList[4].Courses"
              :key="index+500"
              :index="item.Id"
              :item="item"
            >
            </courseItem>
          </div>
        </div>

        <div class="t6" v-if="home_info.CatalogCourseList">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-pic.png" />
              <span class="font-color-34">{{
                home_info.CatalogCourseList[5].pre
              }}</span>
              <span class="last font-color-48">{{
                home_info.CatalogCourseList[5].tail
              }}</span>
            </div>
            <div
              class="more flex align-center cursor-pointer"
              @click="toCourse(home_info.CatalogCourseList[5].CatalogId)"
            >
              <p class="font-color-87 font-size-25">更多</p>
              <img
                class="icon"
                src="../../../assets/home/icon-home-arrow.png"
              />
            </div>
          </div>
          <div class="width flex flex-wrap">
            <courseItem
              v-for="(item, index) in home_info.CatalogCourseList[5].Courses"
              :key="index+600"
              :index="item.Id"
              :item="item"
            >
            </courseItem>
          </div>
        </div>

        <div class="t7" v-if="home_info.CatalogCourseList">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-act.png" />
              <span class="font-color-34">{{
                home_info.CatalogCourseList[6].pre
              }}</span>
              <span class="last font-color-48">{{
                home_info.CatalogCourseList[6].tail
              }}</span>
            </div>
            <div
              class="more flex align-center cursor-pointer"
              @click="toCourse(home_info.CatalogCourseList[6].CatalogId)"
            >
              <p class="font-color-87 font-size-25">更多</p>
              <img
                class="icon"
                src="../../../assets/home/icon-home-arrow.png"
              />
            </div>
          </div>
          <div class="width flex flex-wrap">
            <courseItem
              v-for="(item, index) in home_info.CatalogCourseList[6].Courses"
              :key="index+700"
              :index="item.Id"
              :item="item"
            >
            </courseItem>
          </div>
        </div>

        <!-- <div class="t8" v-if="home_info.CatalogCourseList">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-news.png" />
              <span class=" font-color-34">{{home_info.CatalogCourseList[7].pre}}</span>
              <span class="last font-color-48">{{home_info.CatalogCourseList[7].tail}}</span>
            </div>
            <div class="more flex align-center cursor-pointer" @click="toCourse(home_info.CatalogCourseList[7].CatalogId)">
              <p class=" font-color-87 font-size-25">更多</p>
              <img class="icon" src="../../../assets/home/icon-home-arrow.png">
            </div>
          </div>
          <div class="width flex flex-wrap">
            <courseItem v-for="(item,index) in home_info.CatalogCourseList[7].Courses" :key="index" :index="item.Id" :item="item">
            </courseItem>
          </div>
        </div> -->

        <!-- <div class="act" v-if="home_info.Activity">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-act.png" />
              <span class=" font-color-34">少儿</span>
              <span class="last font-color-48">活动</span>
            </div>
            <div class="more flex align-center cursor-pointer" @click="toMoreAct">
              <p class=" font-color-87 font-size-25">更多</p>
              <img class="icon" src="../../../assets/home/icon-home-arrow.png">
            </div>
          </div>
          <div v-if="home_info.Activity" class="act-content cursor-pointer width" :style="{ backgroundImage: 'url(' + home_info.Activity.Banner + ')' }" @click="toAct"></div>
        </div> -->

        <!-- <div class="news" v-if="home_info.Article">
          <div class="t align-center justify-around flex-relative">
            <div class="flex align-center">
              <img class="img" src="../../../assets/home/icon-home-news.png" />
              <span class=" font-color-34">少儿</span>
              <span class="last font-color-48">资讯</span>
            </div>
            <div class="more flex align-center cursor-pointer" @click="toMoreNews">
              <p class=" font-color-87 font-size-25">更多</p>
              <img class="icon" src="../../../assets/home/icon-home-arrow.png">
            </div>
          </div>

          <div class="width flex flex-wrap">
            <div class="n-item" v-for="item in home_info.Article" :key="item.Id" @click="toNewsDetail(item.Id)">
              <div class="img" :style="{ backgroundImage: 'url(' + item.ImageUrl + ')' }"></div>
              <div class="flex flex-direction flex-sub padding-l-r-15 txt">
                <span class="title font-size-24 font-color-34"
                  >{{item.Title}}</span
                >
                <span class="sub font-size-18 font-color-a1"
                  >{{item.Intro}}</span
                >
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class='page-foot-num'>
      <p class=" font-size-14 font-color-ff">-- 全库共计{{ home_info.CourseCount }}门课程，{{ home_info.VideoCount }}篇视频 --</p>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import common from "@/utils/common.js";
let vm = null;
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          grabCursor: true,
          direction: "horizontal",
          stopOnLastSlide: false,
          delay: 9000,
        },
        pagination: {
          clickable: true,
          el: ".swiper-pagination",
          bulletClass: "bullet",
          bulletActiveClass: "bullet-active",
        },
        autoplayDisableOnInteraction: false,
        on: {
          click(res) {
            const { realIndex } = this;
            vm.bannerTap(realIndex);
          },
          slideChangeTransitionEnd() {
            const { realIndex } = this;
            console.log(vm, realIndex);
            vm.bannerIndex = realIndex;
            vm.requestExpend(realIndex, true);
          },
        },
      },
      hotrec: [],
      home_info: {},
      bannerIndex: 0,
      cateId: 0,
    };
  },
  computed: {
    // 定义swiper，在下面就可以引用这个swiper了；
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.request();
    this.$refs.navbar.setCurrId(0, 1);
    vm = this;
    // let script = document.getElementById("gaodeMapScript");
    // // if(this.map) return;
    // // this.isBodyLoading = true;
    // if (!script) {
    //   script = document.createElement("script");
    //   script.id = "gaodeMapScript";
    //   script.src =
    //     "https://h5.cdn.bjadks.com/website/jiandang100/header.js?v=1.0";
    //   document.body.append(script);
    //   script.addEventListener("load", (e) => {
    //     console.log(e);
    //     // setTimeout(this.marker,500);
    //   });
    // } else {
    //   // this.marker();
    // }
  },
  methods: {
    request() {
      var that = this;
      this.getRequest("api/v1/Home").then((res) => {
        // if (res.IsSuccess) {
        //   console.log(res);
        //   that.home_info = res.Data
        // }
        res.Data.CatalogCourseList.forEach((item) => {
          item["pre"] = item.CatalogName.substring(
            0,
            item.CatalogName.length - 2
          );
          item["tail"] = item.CatalogName.substring(
            item.CatalogName.length - 2,
            item.CatalogName.length
          );
        });
        console.error(common.getCookie('utoken'),'****')
        that.home_info = res.Data;
      });
    },
    swiperEvent(e) {
      console.log(e);
    },
    requestExpend(index, expend) {
      const data = this.home_info.Banners[index];
      // "id":52,"title":"愿你，愿我，愿他不受疟疾困扰！","publishTime":"2021-11-30 08:53:09","contentType":1,"logType":2,"productId":1,"customerId":1,"sourceType":"WeChat","userId":35,"userName":null,"customerCode":"adks","pageUrl":"/pages/playvideo/playvideo?courseId=61310","previousPageUrl":"/pages/tapbar/home/home"
      this.postRequestVisit("Api/v1/Log/SpreadLog", {
        id: data.Id,
        title: data.Title || "",
        publishTime: data.UpdateTime,
        contentType: data.Type,
        logType: expend ? 2 : 0,
        productId: 3,
        sourceType: "PC",
        customerId: common.userBase ? common.userBase.ComId : 0,
        userId: common.userBase ? common.userBase.UserId : 0,
        userName: common.userBase ? common.userBase.UserName : "",
        customerCode: common.userBase ? common.userBase.ComCode : "",
        pageUrl: "https://kids.bjadks.com",
        previousPageUrl: "https://kids.bjadks.com" + data.GotoUrl,
      });
    },
    toAct() {
      var that = this;
      this.$router.push({
        name: "activitydes",
        params: {
          id: that.home_info.Activity.Id,
        },
      });
    },
    toCourse(cateId) {
      this.$router.push({
        name: "list",
        query: { type: 1, id: cateId },
      });
      // this.$router.push({
      //   name: "course",
      //   params: {
      //     Id: cateId,
      //   },
      // });
    },
    toMoreAct() {
      this.$router.push({
        name: "activity",
      });
    },
    toMoreNews() {
      this.$router.push({
        name: "news",
      });
    },
    toNewsDetail(nId) {
      this.$router.push({
        name: "detail",
        params: {
          Id: nId,
        },
      });
    },
    bannerTap(index) {
      this.requestExpend(index);
      const b = this.home_info.Banners[index];
      let url = b.GotoUrl;
      if (b.InsideType === 1) {
        let ary = url.split("/");
        let videoId = ary.pop();
        let cateId = ary.pop();
        let courseId = ary.pop();
        let routeData = this.$router.resolve({
          name: "video",
          params: {
            cateId: cateId,
            Id: courseId,
            videoId: videoId,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (b.InsideType === 3) {
        window.open(url, "_blank");
      } else if (b.InsideType === 2) {
        window.open(`https://promotion.bjadks.com/#/?topicId=${b.DataId}`, "_blank");
      }
    },
    bannerSwich(index) {
      if (index == this.bannerIndex) {
        return;
      }
      this.bannerIndex = index;
      this.swiper.slideTo(index + 1, 500, true);
    },
  },
};
</script>

<style scoped>
.banner {
  position: relative;
  height: 5.2rem;
}
.swiper {
  width: 100%;
  z-index: 1;
}
.swiper-item {
  width: 100%;
  height: 5.2rem;
}

.swiper-item .img {
  height: 5.2rem;
  background-size: auto 5.2rem;
  background-repeat: no-repeat;
  background-position: top center;
}

.home-bg {
  background: url("../../../assets/home/icon-home-bg.png") top center;
  background-repeat: no-repeat;
  background-size: auto 56.9rem;
  min-height: 10rem;
  margin-top: -0.68rem;
}

.hot {
  margin-top: 1rem;
}

.t1 {
  margin-top: 1rem;
}

.t1 .t .img {
  width: 0.77rem;
  height: 0.81rem;
}

.t2 {
  margin-top: 1.6rem;
}

.t2 .t .img {
  width: 0.84rem;
  height: 0.74rem;
}

.t3 {
  margin-top: 1.4rem;
}

.t3 .t .img {
  width: 0.85rem;
  height: 0.79rem;
}

.t4 {
  margin-top: 1.3rem;
}

.t4 .t .img {
  width: 0.84rem;
  height: 0.84rem;
}

.t5 {
  margin-top: 1.3rem;
}

.t5 .t .img {
  width: 0.9rem;
  height: 0.79rem;
}

.t6 {
  margin-top: 1.3rem;
}

.t6 .t .img {
  width: 0.71rem;
  height: 0.81rem;
}

.t7 {
  margin-top: 1.3rem;
}

.t7 .t .img {
  width: 0.9rem;
  height: 0.9rem;
}

.t8 {
  margin-top: 2.4rem;
  margin-bottom: 1rem;
}

.t8 .t .img {
  width: 0.82rem;
  height: 0.88rem;
}

.t {
  margin-bottom: 0.4rem;
}

.home-bg .c {
  margin: 0 auto;
}

.t .line {
  width: 4.7rem;
  height: 0.01rem;
  border-bottom: 0.01rem dashed #607167;
}

.t .img {
  width: 0.76rem;
  height: 0.9rem;
  margin-right: 0.24rem;
}

.t span {
  font-size: 0.48rem;
}

.t .last {
  margin-right: 0.67rem;
}

.item {
  margin-right: 0.46rem;
  margin-bottom: 0.3rem;
  background-color: #fff;
}

.item:nth-child(4n) {
  margin-right: 0;
}

.act {
  margin-top: 1rem;
}

.act .t .img {
  width: 0.9rem;
  height: 0.9rem;
}

.act-content {
  height: 4.52rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 0.1rem;
}

.news {
  margin-top: 0.8rem;
}

.news .t .img {
  width: 0.82rem;
  height: 0.88rem;
}

.news .n-item {
  width: 6.72rem;
  height: 1.8rem;
  margin-bottom: 0.36rem;
  margin-right: 0.55rem;
  background-color: #fff;
  border-radius: 0.1rem;

  padding: 0.2rem 0.2rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
}

.news .n-item .txt {
  height: 100%;
}

.news .n-item .img {
  width: 1.34rem;
  height: 1.34rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.news .n-item .title {
  line-height: 0.48rem;
  max-height: 0.48rem;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.news .n-item .sub {
  line-height: 0.3rem;
  max-height: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.news .n-item:nth-child(2n) {
  margin-right: 0;
}

.swiper-pagination-bullets {
  bottom: 0.5rem;
  left: 0;
  width: 100%;
}

.more {
  position: absolute;
  right: 0;
}

.more .icon {
  width: 0.13rem;
  height: 0.23rem;
  margin-left: 0.1rem;
}

.pagination {
  position: absolute;
  bottom: 0.7rem;
  left: 0;
  width: 100%;
  height: 0.4rem;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagitation-point {
  margin-right: 0.2rem;
}

.page-foot-num {
  height:0.4rem;
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-foot-num p {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/tab/navigation/home.vue